/* eslint-disable no-param-reassign */
import crypto from 'crypto';
import CryptoJS from 'crypto-js';
import Axios from "axios";
import { Modal, Toast } from 'antd-mobile';
import Constant from 'Constantjs';
import Client from './http/client';

const SKSXENV = process.env.REACT_APP_SKSXENV;
const NODEENV = process.env.NODE_ENV;
const skipApi = ['/login/mock', '/frontend/login', '/frontend/sms/send', '/user/frontend/account/bind', '/frontend/getFormId', '/frontend/mobile/code/send', '/frontend/mobile/code/verify', '/market/subject/read/seckill', 
'/market/subject/read/seckillData', '/packageist/subject/read/detail', '/market/subject/searchProduct','/market/marketing/page/detail', '/market/marketing/page/products/page','/coupon/app/small/marketing/bathMarketingInfoByIds'];

const mSecret = {
  dev: {
    // 火山鉴权
    HSAK: 'APIGOGFjZGJjOTRmYmQ4NGY5YmFlODhkMmZiYjJiMmFjNmM',
    HSSK: 'OGIwMGNhMTZkNzA2NDM5Yjg3NGJiZTdlMmZkZDZhYjQ',
    // 腾讯网关鉴权
    SecretId: 'AKIDimdhbovgdhz9rkpusw5K5mbju9llp6ginl3k',
    SecretKey: '6TyvxdeLzPdF4q1Tbfo81zJJ1U0527kO7qVi0n7g',
  },
  test: {
    // 火山鉴权
    HSAK: 'APIGOGFjZGJjOTRmYmQ4NGY5YmFlODhkMmZiYjJiMmFjNmM',
    HSSK: 'OGIwMGNhMTZkNzA2NDM5Yjg3NGJiZTdlMmZkZDZhYjQ',
    // 腾讯网关鉴权
    SecretId: 'AKIDimdhbovgdhz9rkpusw5K5mbju9llp6ginl3k',
    SecretKey: '6TyvxdeLzPdF4q1Tbfo81zJJ1U0527kO7qVi0n7g',
  },
  prod: {
    // 火山鉴权
    HSAK: 'APIGY2Y1ZjZiMWNiMWQ4NGJmOWJjZWI2YzEzYzgyYTQ3YzE',
    HSSK: 'NDk3MGRlYjg3NjBlNDdlZThiNjhkMjczNzRiOGVmMGE',
    // 腾讯网关鉴权
    SecretId: 'AKIDGmx7p5pb16001dU2tyl8uiz027lkknm2F776',
    SecretKey: 'a6YVHd3dG92WfQf7G0EQjFT6ju5r81K06DB0qL2',
  }
};
const apiOrigin = {
  wx: {
    test: 'https://wx.btgsmartlink.net',
    prod: 'https://wx.btghl.com'
  },
  m: {
    // TODO
    test: 'https://m.api.btgsmartlink.net',
    // test: 'https://hs-m.api.btghl.com',
    prod: 'https://m.api.btghl.com'
  },
  j: {
    test: 'https://customer.api.btgsmartlink.net/customer',
    prod: 'https://customer.api.btghl.com'
  },
  yx: {
    test: 'https://yx.btgsmartlink.net',
    prod: 'https://yx.btgsmartlink.net'
  },
  limit: {
    test: 'https://html-1253289665.cos.ap-beijing.myqcloud.com/',
    prod: 'https://html-1253289665.cos.ap-beijing.myqcloud.com/'
  }
};

const hostData = {
  wx: {
    development: '/api',
    production: apiOrigin.wx[SKSXENV]
  },
  m: {
    development: '/mapi',
    production: apiOrigin.m[SKSXENV]
  },
  j: {
    development: '/java',
    production: apiOrigin.j[SKSXENV]
  },
  yx: {
    development: 'https://yx.btgsmartlink.net',
    production: apiOrigin.yx[SKSXENV]
  },
  limit: {
    development: '/limit',
    production: apiOrigin.limit[SKSXENV]
  }
};

const limitRequest = () => {
  const url = ['dev', 'test'].indexOf(SKSXENV) > -1 ? 'ubr-wx-h5-threshold-test.json' : 'ubr-wx-h5-threshold.json';
  return new Promise((resolve) => {
    Axios.request({
      baseURL: hostData.limit[NODEENV],
      url: `${url}?t=${+new Date()}`
    }).then(res => {
      const { probability } = res.data;
      resolve(probability);
    }).catch(() => {
      resolve([]);
    });
  });
};

const calTimestampDiff = (res) => {
  if(res && res.data && res.data.result) {
    const now = +new Date();
    const result = +res.data.result * 1000;
    const cha = now - result;
    window.sksxTimestampDiff = cha;
    return;
  }
  window.sksxTimestampDiff = 1;
  // eslint-disable-next-line no-console
  console.error('获取时间戳失败');
};

const mHeaders = (url) => {
  /** 如果window.sksxTimestampDiff无值，说明是在请求timestamp接口，无需设置header */
  if(!window.sksxTimestampDiff){
    return {};
  }
  const timestampDiff = window.sksxTimestampDiff;
  const nowDate = +new Date(); 
  const xDate = new Date(nowDate - timestampDiff).toGMTString();

  // const dateTime = nowDate.toGMTString();

  const { SecretId, SecretKey } = mSecret[SKSXENV];
  
  const source = 'WxWap'; // 签名水印值，可填写任意值

  const auth = `hmac id="${SecretId}", algorithm="hmac-sha1", headers="x-date source nonce", signature="`;

  const nonce = crypto.randomBytes(8).toString('hex').slice(0, 8);

  const signStr = `x-date: ${xDate}\nsource: ${source}\nnonce: ${nonce}`; 

  let sign = CryptoJS.HmacSHA1(signStr, SecretKey);

  sign = CryptoJS.enc.Base64.stringify(sign);

  sign = `${auth}${sign}"`;

  let token = window.localStorage.getItem('token');
  token = token ? JSON.parse(token) : '';

  const obj = {
    "Source": source,
    "X-Date": xDate,
    "Authorization": sign,
    "Nonce": nonce
  };

  if (token) {
    obj['X-Authorization'] = token;
  }

  const { otherMiniApp } = window.sayhi;
  if (Constant.payApis.indexOf(url) > -1 && otherMiniApp) {
    obj["webview-source"] = otherMiniApp;
  }

  if(!(window.location.host.indexOf('btghl') > -1 || window.location.host.indexOf('btgsmartlink') > -1)){
    obj["X-Origin"] = window.location.hostname;
  }

  return obj;
};

const resHeaderToLowerCase = (headers) => {
  const lowerCaseHeaders = {};
  const keys = Object.keys(headers);
  keys.map(key => {
    lowerCaseHeaders[key.toLowerCase()] = headers[key];
    return key;
  });
  return lowerCaseHeaders;
};

const setToken = (url, res) => {
  if(url === '/frontend/login' || url === '/login/mock') { // 如果正在登录的话，把登录后的token存到localStorage
    const {code, data: resData} = res.data;
    if(code === 0) {
      const {user} = resData;
      if(url === '/frontend/login' && user.user.token) {
        window.localStorage.setItem('token', JSON.stringify(user.user.token));
      }
      if(url === '/login/mock' && user.token) {
        window.localStorage.setItem('token', JSON.stringify(user.token));
      }
    }        
  } else { // 非登录接口时，若header头里返回x-auth时，需要更新token
    const lowercaseHeaders = resHeaderToLowerCase(res.headers);
    const { authorization, 'x-authorization': authorization1 } = lowercaseHeaders;
    const token = authorization1 || authorization;
    if(token){
      window.localStorage.setItem('token', JSON.stringify(token));
    }
  }
};

// 检查是否需要判断Authorization
const checkSkipApi = (url) => (skipApi.indexOf(url) < 0 && !skipApi.find(i => url.indexOf(i) >= 0));
// 获取网关header
// eslint-disable-next-line no-unused-vars
const getHSGatewayHeader = (config) => {
  const { HSAK, HSSK } = mSecret[SKSXENV];
  const { method, url, params, data } = config;

  const baseURL = NODEENV === 'development' ? 'https://m.api.btgsmartlink.net' : 'https://m.api.btghl.com';

  // 火山鉴权需要的headers
  const urlAll = `${baseURL}${url}`;
  const client = new Client(HSAK, HSSK);
  const result = client[method](urlAll, {
      ...(method === 'post' ? { data } : { query: params || data })
    });
  return result;
};

const request = (type, url, method, params = {}) => {
  params = params || {};
  const data = method === 'get' ? 'params' : 'data';
  // let isLoginRequest = false; // 是否正在登录
  // if(NODEENV === 'production' && url === '/frontend/login') {
  //   isLoginRequest = true;
  // }
  // if(NODEENV === 'development' && url === '/login/mock') {
  //   isLoginRequest = true;
  // }
  const reqParams = {
    url,
    method,
    baseURL: hostData[type][NODEENV],
    [data]:params
  };
  if (Constant.payApis.indexOf(url) > -1 && window.sayhi.isBtgApp) { 
    // app webview调支付时
    reqParams.orderSource = '1';
  }
  if (url !== '/timestamp') {
    reqParams.headers = mHeaders(url);
  }
  // 火山鉴权
  if (type === 'm') {
    reqParams.headers = Object.assign({'Accept': 'application/json'}, reqParams.headers, getHSGatewayHeader(reqParams));
  }
  // eslint-disable-next-line no-console
  console.log('reqParams', reqParams);
  return new Promise((resolve) => {
    if (window.sayhi.isWebviewLoging && checkSkipApi(url)) {
      Toast.hide();
      return;
    }
    if (type === 'm' && checkSkipApi(url) && !reqParams.headers.Authorization) {
      Toast.hide();
      return;
    }
    if (url === '/timestamp' && window.sksxTimestampDiff) {
      resolve();
      return;
    }
    Axios(reqParams).then(res => {
      setToken(url, res);
      const { code, httpCode } = res.data;
      if (url === '/timestamp') {
        calTimestampDiff(res);
        resolve();
        return;
      }
      if(code === 504 || code === 401 || httpCode === 401) {
        window.sayhi.isWebviewLoging = true;
        window.sayhi.pub('needLogin');
        Toast.hide();
        return;
      };
      res.data.headers = res.headers;
      resolve(res.data);
    }).catch(err => {
      if (url === '/timestamp') {
        calTimestampDiff();
        resolve();
        return;
      }
      // eslint-disable-next-line no-console
      console.error('=========', err);
      Toast.hide();
      Modal.alert('温馨提示','网络错误1');
    });
  });
};


const http = {
  get: (url, params = {}) => request('wx', url, 'get', params),
  post: (url, params = {}) => request('wx', url, 'post', params),
  getTimestamp: (url, params = {}) => request('yx', url, 'post', params),
  mGet: (url, params = {}) => request('m', url, 'get', params),
  mPost: (url, params = {}) => request('m', url, 'post', params),
  jGet: (url, params = {}) => request('j', url, 'get', params),
  jPost: (url, params = {}) => request('j', url, 'post', params),
  limitRequest
};

export default http;